import { DEFAULT_LAYOUT } from '../base';
import { AppRouteRecordRaw } from '../types';

const HOMEPAGE: AppRouteRecordRaw = {
  path: '/homePage',
  name: 'homePage',
  component: DEFAULT_LAYOUT,
  redirect: '/homePage/index',
  meta: {
    locale: '首页',
    icon: 'icon-file',
    order: 0,
    requiresAuth: true,
    hideInMenu: false,
  },
  children: [
    {
      path: 'index',
      name: '首页',
      component: () => import('@/views/homePage/index.vue'),
      meta: {
        locale: '首页',
        hideInMenu: false,
        requiresAuth: true,
        roles: ['*'],
      },
    },
    {
      path: 'self-order',
      name: 'HomePageSelfOrderRedirect',
      redirect: '/charging/self-order',
      meta: {
        locale: '自有平台充电订单',
        hideInMenu: true,
        requiresAuth: true,
        roles: ['*'],
      },
    },
    {
      path: 'order',
      name: 'HomePageOrderRedirect',
      redirect: '/charging/order',
      meta: {
        locale: '三方引流平台订单',
        hideInMenu: true,
        requiresAuth: true,
        roles: ['*'],
      },
    },
  ],
};
export default HOMEPAGE;
